"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _BaseEdit = _interopRequireDefault(require("../containers/BaseEdit"));
var _BaseList = _interopRequireDefault(require("../containers/BaseList"));
var _BaseShow = _interopRequireDefault(require("../containers/BaseShow"));
var _BaseCreate = _interopRequireDefault(require("../containers/BaseCreate"));
var _BaseImport = _interopRequireDefault(require("../containers/BaseImport"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const ContainerFactory = (options, actions) => {
  const singular = options.singular || options.plural.slice(0, -1);
  const plural = options.plural || options.singular + 's';
  let List = ({
    children,
    ...rest
  }) => /*#__PURE__*/_react.default.createElement(_BaseList.default, _extends({}, rest, {
    singular: singular,
    plural: plural,
    actions: actions,
    schema: options.schema || rest.schema
  }), _react.default.cloneElement(children, rest));
  let Edit = ({
    children,
    ...rest
  }) => /*#__PURE__*/_react.default.createElement(_BaseEdit.default, _extends({}, rest, {
    singular: singular,
    plural: plural,
    actions: actions,
    schema: options.schema || rest.schema
  }), _react.default.cloneElement(children, rest));
  let Show = ({
    children,
    ...rest
  }) => /*#__PURE__*/_react.default.createElement(_BaseShow.default, _extends({}, rest, {
    singular: singular,
    plural: plural,
    actions: actions,
    schema: options.schema || rest.schema
  }), _react.default.cloneElement(children, rest));
  let Create = ({
    children,
    ...rest
  }) => /*#__PURE__*/_react.default.createElement(_BaseCreate.default, _extends({}, rest, {
    singular: singular,
    plural: plural,
    actions: actions,
    schema: options.schema || rest.schema
  }), _react.default.cloneElement(children, rest));
  let Import = ({
    children,
    ...rest
  }) => /*#__PURE__*/_react.default.createElement(_BaseImport.default, _extends({}, rest, {
    singular: singular,
    plural: plural,
    actions: actions,
    schema: options.schema || rest.schema
  }), _react.default.cloneElement(children, rest));
  List.displayName = `List${(0, _helpers.capitalize)(plural)}`;
  Edit.displayName = `Edit${(0, _helpers.capitalize)(singular)}`;
  Show.displayName = `Show${(0, _helpers.capitalize)(singular)}`;
  Create.displayName = `Create${(0, _helpers.capitalize)(singular)}`;
  Import.displayName = `Import${(0, _helpers.capitalize)(singular)}`;
  return {
    List,
    Edit,
    Show,
    Create,
    Import
  };
};
var _default = exports.default = ContainerFactory;
module.exports = exports.default;